import { DialogObject } from '../../../../components/dialog/dialog.types';

interface getAgpmDeleteObjectProps {
  representation?: string;
  action: () => void;
  toggleVisiblity?: () => void;
}

export const getAgpmDeleteObject = ({ representation, action, toggleVisiblity }: getAgpmDeleteObjectProps): DialogObject => {
  return {
    title: `Suppression d'un Avis Général de Passation de Marché ${representation}`,
    description: '',
    actions: [
      {
        label: 'Supprimer',
        variant: 'danger',
        onClick: () => action?.(),
      },
      {
        label: 'Annuler',
        onClick: () => toggleVisiblity?.(),
        variant: 'secondary',
      },
    ],
  };
};
